import React from 'react'

const CoC = () => (
  <section className="ts-blog section-bg">
    <a id="coc" className="anchor" />
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <h2 className="section-title">
            <span>Code of Conduct</span>
            SRE NEXT 行動規範
          </h2>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-10 mx-auto">
          <div className="single-intro-text mb-30">
            <p>
              SRE NEXT 行動規範は、SRE NEXT 参加者および SRE NEXT
              を通じて提供されるコンテンツに適用されます。「SRE NEXT
              参加者」には、チケットを購入しご来場した参加者だけでなく、運営スタッフ、スピーカー、スポンサー、その他サポートいただく関係者の皆様を含み、また「SRE
              NEXT
              を通じて提供されるコンテンツ」には発表されるトーク内容をはじめ、公式に提供されるコミュニケーションツール（Slack、Twitterなど）やスタッフが公開するブログ記事などを含みます。
              <br />
              これはイベントに関わるすべての人にとって安心・安全なイベント体験を提供するためのものです。
            </p>
            <h3 className="coc-title">ハラスメントをしない</h3>
            <p>
              SRE NEXT
              はあらゆるハラスメント行為を認めません。性別、性的指向、身体障害、外見、体型、人種や宗教、以上に限らず、ハラスメントと思われる振る舞いをしてはいけません。
            </p>
            <h3 className="coc-title">すべての参加者を尊重する</h3>
            <p>
              参加者、スピーカー、運営、スポンサー、様々なひとの善意でイベントは成り立っています。それらすべての人々に敬意を払い、攻撃・侮蔑を行う行為、発言をしてはいけません。
            </p>
            <h3 className="coc-title">参加者の安全を脅かさない</h3>
            <p>
              危険物の持ち込み、および会場設備の破壊行為をしてはいけません。
            </p>
            <h2 className="coc-title">行動規範の運用</h2>
            <p>
              SRE NEXT に関わる皆様に、CoC を事前に配布いたします。また、SRE
              NEXT 開会時にも、参加者の皆様に改めて周知を行います。
              <br />
              また、行動規範を違反する特定の人物や出来事について懸念がある方は、
              sre.next
              <span className="atmark" />
              gmail.com
              までご連絡ください。スタッフで可能な限りの予防措置を検討・実施させていただきます。
            </p>
            <p>
              違反行為や発言を発見した方は、スタッフにご連絡ください。スタッフは、会場ではスタッフTシャツを着ています。
              <br />
              スタッフは、行動規範に違反している行為を発見した場合、即座に中止を求めます。退場処分とする場合もございます。その場合、受領している参加費・スポンサー費の返金処理は行いません。
              <br />
              さらに、イベントから出入禁止とすること、また会場およびWeb上でのコンテンツについて掲載を取りやめることもありえます。
            </p>
            <p>
              ※本文章は{' '}
              <a
                href="https://creativecommons.org/publicdomain/zero/1.0/deed.ja"
                target="_blank"
              >
                Creative Commons Zero license
              </a>{' '}
              で公開されています。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default CoC
